"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortRangeRentThreshold = exports.MaxBedroomCount = exports.DateFlexibility = exports.NoStartDateMonthLimit = void 0;
var NoStartDateMonthLimit = 4;
exports.NoStartDateMonthLimit = NoStartDateMonthLimit;
var DateFlexibility = 14;
exports.DateFlexibility = DateFlexibility;
var MaxBedroomCount = 8;
exports.MaxBedroomCount = MaxBedroomCount;
var ShortRangeRentThreshold = 28;
exports.ShortRangeRentThreshold = ShortRangeRentThreshold;